import { motion } from 'framer-motion'
import './OrderHeader.css'

export default function OrderHeader() {
    return (
        <section className="order-header">
            <div className="header-bg">
                <div className="mesh-gradient"></div>
                <div className="block-flow"></div>
            </div>

            <div className="container">
                <motion.div
                    className="header-content"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="header-badge">
                        <span className="live-dot"></span> Live Network
                    </div>

                    <h1 className="header-title">
                        <span className="text-gradient">Flash Order</span>
                    </h1>
                    <p className="header-subtitle">
                        Instant execution. <span className="text-neon">Zero latency.</span>
                    </p>

                    <div className="header-features">
                        <div className="feature-pill">
                            <span>Secure Escrow</span>
                        </div>
                        <div className="feature-pill">
                            <span>Instant Settlement</span>
                        </div>
                        <div className="feature-pill">
                            <span>Multi-Chain</span>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    )
}


